import common from './common';

export default class SaveData {

    get data() {
        return this._data;
    }

    constructor() {
        this._data = {
            mute: false,
            voMute: false,
            musicMute: false,
            charactersPlayed: [
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ]
        };
        this.load();
    }

    save() {
        const data = JSON.stringify(this._data);
        const name = common.config.save.name + common.config.save.version;
        localStorage.setItem(name, data);
    }

    load() {
        const name = common.config.save.name + common.config.save.version;
        const data = localStorage.getItem(name);
        data && (this._data = JSON.parse(data));

        if (!this._data.charactersPlayed) {
            this._data.charactersPlayed = [
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ]
        }
        //P3.audio.mute(this._data.mute);
    }
}